import "./App.css";
import Header from "./components/header";
import Products from "./components/products";

const App = () => {
  return (
    <div>
      <Header />
      <Products />
    </div>
  );
};

export default App;
